module.exports = __webpack_public_path__ + "static/img/sx_empty.36ba414.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sx_empty.png
// module id = q7h2
// module chunks = 167